
<template>
    <svg xmlns="http://www.w3.org/2000/svg" id="human2be" viewBox="0 0 500 500">
                  <switch>
                     <g>
                        <g>
                           <g>
                              <g>
                                 <path class="h2be_b" d="M278.1 321.3h-66.5c1.2-11.5 15.8-31.3 29.6-44.6 20.3-19.6 44.4-38.7 44.4-71.6 0-29.8-16.9-45.7-47.9-45.7-32.1 0-47.8 17.6-47.8 44.8 0 5.2 4.3 9.5 9.5 9.5s9.5-4.3 9.5-9.5c0-17.2 10.1-26.4 28.9-26.4 18.7 0 29 9.6 29 25.5 0 28-15.9 37.9-35.5 56.6-18.4 17.6-41.3 43.5-41.3 70.8 0 7.5 5.4 9.9 8.3 9.9h79.9c5.4 0 9.8-4.3 9.8-9.7-.1-5.4-4.5-9.6-9.9-9.6z"></path>
                              </g>
                              <path class="h2be_2" d="M356.4 216.6c-14.1 0-25.2 6.3-31.7 12.9v-60.4c0-5.5-4.3-9.7-9.7-9.7-5.5 0-9.7 4.3-9.7 9.7v121.3c0 31.5 18.7 50.4 50.1 50.4 33.8 0 52.3-22.4 52.3-63.2.1-40.5-17.2-61-51.3-61zm-1 105.8c-11.5 0-30.7-4.2-30.7-32v-35.6c1.3-2.7 10.3-20.2 30.7-20.2 21.8 0 32.9 14.5 32.9 43 0 29.7-11 44.8-32.9 44.8z"></path>
                              <path class="h2be_h" d="M206.6 261.2c0-28-18.2-44.7-48.8-44.7-11.8 0-21.7 2.5-29.5 7.1v-19.7c0-16.2 10.4-25.9 27.9-25.9.1 0 5.4 0 6.9-.2 5-.6 8.5-4.5 8.5-9.4s-3.5-8.5-8.7-9.1c-.7-.1-2.5-.1-7.5-.1-28.6.3-46.4 17.4-46.4 44.7v126.8c0 5.3 4.3 9.7 9.7 9.7 5.3 0 9.7-4.3 9.7-9.7v-69.4c0-16.1 10.7-25.4 29.4-25.4s29.4 9.3 29.4 25.4V294c4.8-8.8 11.2-17.8 19.3-27.1v-5.6c.1 0 .1-.1.1-.1z"></path>
                           </g>
                           <g>
                              <circle class="h2be_dot" cx="475.3" cy="325.6" r="9.7"></circle>
                              <path class="h2be_circle" d="M460.5 384.9c.1-.1.2-.2.3-.4 2.9-4.5 1.6-10.5-2.9-13.4s-10.5-1.6-13.4 2.9c-.1.2-.3.5-.4.7-44.2 68.6-123.6 111.6-210.7 105.2-127-9.3-222.4-119.8-213.1-246.7C29.6 106.2 140.1 10.8 267 20.1c126.7 9.3 222 119.5 213 246.3-.4 5.4 3.6 10 9 10.4 5.4.4 10-3.6 10.4-9 9.8-137.5-93.6-257-231.1-267.1C130.5-9.4 10.7 94.1.7 231.8-9.4 369.5 94.1 489.3 231.8 499.3c94.6 6.9 180.8-39.8 228.7-114.4z"></path>
                           </g>
                        </g>
                     </g>
                  </switch>
               </svg>
</template>
<script>
export default {
    
}
</script>
<style scoped lang="scss">
    #human2be {
        fill: #3f6f93;
        max-width: 50px;
        width: 50px;
    }
    #human2be .h2be_dot,#human2be .h2be_h {
    -webkit-transition: all .5s ease;
    transition: all .5s ease;
  }
  
  #human2be .h2be_2 {
    -webkit-transition: all .3s ease;
    transition: all .3s ease;
  }
  
  #human2be .h2be_b {
    -webkit-transition: all .5s ease;
    transition: all .5s ease;
  }
  
  #human2be .h2be_circle {
    -webkit-transition: all .7s ease;
    transition: all .7s ease;
  }
  
  #human2be:hover .h2be_2,#human2be:hover .h2be_b,#human2be:hover .h2be_circle {
    fill: #0ab49b;
  }
  
  #human2be:hover .h2be_dot,#human2be:hover .h2be_h {
    fill: #fff;
  }
</style>